import React, { Component } from 'react';
import API from '../../services/API';
import { Row, Col, Button, Pagination } from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Icon from '../../components/Icon';
import Table from './components/Table';
import Form from './components/Form';

class CalendarEvents extends Component {
    constructor() {
        super();

        this.state = {
            events: [],
            isLoading: false,
            isShowForm: false,
            eventToUpdate: null,

        };

        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
    }

    componentDidMount() {
        this.loadEvents();
    }

    loadEvents() {
        this.setState({ isLoading: true });

        API.CalendarEvents.get().then(({ events }) => {
            this.setState({ events,  isLoading: false });
        });
    }


    getForm() {
        if(this.state.isShowForm) {
            return (
                <Form
                    onFormHide={this.handleFormHide}
                    onSubmit={this.handleFormSubmit}
                    event={this.state.eventToUpdate}
                />
            );
        }
    }

    handleAddBtnClick() {
        this.setState({
            isShowForm: true,
            selectedMessage: null
        });
    }

    handleUpdate(event) {
        this.setState({ isShowForm: true, eventToUpdate: event });
    }

    handleRemove(id) {
        this.setState({ isLoading: true  });

        API.CalendarEvents.remove(id).then(() => this.loadEvents());
    }

    handleFormHide() {
        this.setState({ isShowForm: false });
    }

    handleFormSubmit({ update, id, ...event }) {
        this.setState({
            isShowForm: false,
            isLoading: true
        });

        if(update) API.CalendarEvents.update(id, event).then(() => this.loadEvents());
        else API.CalendarEvents.save(event).then(() => this.loadEvents());
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Calendar Events"/>
                <Row>
                    <Col lg={12}>
                        <Button className="pull-right m-b-15" bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus"/> Add</Button>
                    </Col>
                </Row>
                {this.getForm()}
                <Table
                    events={this.state.events}
                    onUpdate={this.handleUpdate}
                    onRemove={this.handleRemove}
                />
            </Container>
        );
    }
}

export default CalendarEvents;


// WEBPACK FOOTER //
// ./src/scenes/CalendarEvents/index.js